import { API_ENDPOINT } from '../constants';
import { useCallback, useMemo } from "react";

const useFetch = () => {
    const t = (typeof window !== 'undefined' ? localStorage?.getItem?.('authToken') : null);

    const authToken = useMemo(() => {
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            const token = localStorage?.getItem?.('authToken');
            if (typeof token === 'string' && token) return `Bearer ${token}`;
        }

        return null;
    }, [typeof window, t]);

    const fetcher = useCallback(
        /**
         * 
         * @param {'get' | 'post' | 'put' | 'patch' | 'delete'} method 
         * @param {string} url 
         * @param {Record<string, any>} [data]  
         * @param {{
         *   responseType?: 'json' | 'text' | 'blob' | 'arrayBuffer' | 'formData';
         *   additionalHeaders?: Record<string, any>;
         *   signal?: AbortSignal;
         * }} [config]
         * @returns {Promise<{data: any; error: null;} | {data: null; error: string;}>}
         */
        async (
            method,
            url,
            data = {},
            config = {}
        ) => {

            try {
                const response = await fetch(API_ENDPOINT + url, {
                    method: method.toUpperCase(),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': authToken,
                        ...(config?.additionalHeaders || {})
                    },
                    body: ['get', 'delete'].includes(method.toLowerCase()) ? undefined : JSON.stringify((data || {})),
                    signal: config?.signal
                });

                if (response) {
                    const responseType = config?.responseType || 'json';
                    const result = await response[responseType]();
                    if (result) {
                        if (response.status >= 400) {
                            if (responseType === 'json' && result?.error && typeof result.error === 'string') return {
                                data: null,
                                error: result.error
                            };

                            if (responseType === 'json' && result?.errors && Array.isArray(result.errors)) return {
                                data: null,
                                error: result.errors
                            }

                            return {
                                data: null,
                                error: 'Something went wrong! Please try again later.'
                            };
                        }

                        return {
                            data: result,
                            error: null
                        };
                    }
                }
            } catch (err) {
                console.log('--- useFetch error ---', err);
                return {
                    data: null,
                    error: typeof err?.message === 'string' ? err.message : 'Something went wrong! Please try again later.'
                }
            }

            return {
                data: null,
                error: 'Something went wrong! Please try again later.'
            }
        },
        [authToken, API_ENDPOINT]
    );

    return fetcher;
}

export default useFetch;